/* =============================================================
 * import
 * ========================================================== */
// import {mediaQuery} from '../functions/common';

/* =============================================================
 * function
 * ========================================================== */

import $ from "jquery";

export default function exe() {
  kvSlider(0);

  window.addEventListener('resize', function() {
    kvSlider(0);
  });
}


function kvSlider(delay = 4000) {
  const slider = document.querySelectorAll('.kv_slider');

  // sliderOption
  const opt = {
    targetElm: slider,    // 対象要素のクラス名
    className: 'active',  // 付与するクラス名
    firstDelay: delay,     // 初めのクラス付与までの遅延時間
    duration: 6000,       // 間隔
    startImmediate: true, // 初期状態から1つ目に付与するのか
    oneWay: false,        // 付け替えじゃなくて、片道だけ付けて終わりたいか
  };

  classCycler(opt);
}

function classCycler(opt) {

  let index = 0;
  let timer;
  const item = opt.targetElm;

  if (opt.startImmediate) {
    item[index].classList.add(opt.className);
  }

  const execCycle = () => {
    const max = item.length;

    if (!opt.oneWay) {
      item[index].classList.remove(opt.className);
    }

    index = (++index === max) ? 0 : index;
    item[index].classList.add(opt.className);

    if (opt.oneWay && index === 0) {
      clearInterval(timer);
    }
  };

  setTimeout(function() {
    timer = setInterval(execCycle, opt.duration);
  }, opt.firstDelay);

}

//


// kvコンテンツフェード
$(function() {
  $(".kv_image").css({opacity: '0',
    margin:'30px auto 0'});
  $(".header_gnav").css({opacity: '0'});
  setTimeout(function() {
    $(".kv_image#first").stop().animate({opacity: '1',margin:0}, 500);
    setTimeout(function() {
      $(".kv_image#second").stop().animate({opacity: '1',margin:0}, 500);
      setTimeout(function() {
        $(".header_gnav.pages").stop().animate({opacity: '1'}, 500);
        $(".kv_image#third").stop().animate({opacity: '1',margin:0}, 500);
        setTimeout(function() {
          $(".kv_image#forth").stop().animate({opacity: '1',margin:0}, 500);
          setTimeout(function() {
            $(".kv_image#fifth").stop().animate({opacity: '1',margin:0}, 500);
            setTimeout(function() {
              $(".header_gnav").stop().animate({opacity: '1'}, 500);
            }, 100);
          }, 200);
        }, 200);
      }, 200);
    }, 200);
  }, 300);
});

$(function() {
  let height;
  $(window).on('load', function() {
    height = $('.activity').offset().top + $('.activity').outerHeight();
  });

  $(window).scroll(function() {
    if ($(window).scrollTop() + $(window).height() > height) {
      $('.activity .section_box').addClass('open');
    }
  });
  if (window.matchMedia('(max-width:768px)').matches) {
    let footheight;
    footheight = $(".header_gnav").height();
    console.log(footheight);
    $(".footer").css("margin-bottom", footheight);
  };


});

const show = 3; // 最初に表示する件数
const num = 3;  // もっと見るで表示する件数
const contents = '.main_committee_list li'; // 対象のlist
$(contents + ':nth-child(n + ' + (show + 1) + ')').addClass('is-hidden');
$('.readmore').on('click', function() {
  $(contents + '.is-hidden').slice(0, num).removeClass('is-hidden');
  if ($(contents + '.is-hidden').length == 0) {
    $('.readmore').fadeOut();
  }
});

$('.meeting_list_year').on('click', function() {
  $(this).toggleClass('open');
});
